<template>
  <div class="right-sidebar__marker-guide">
    <div v-for="status in config.rightSidebar?.propertyGuide.items" :key="status" class="guide">
      <AvailabilityMarker :status="status" :isDisplayHome="status === 'Display Home'"></AvailabilityMarker>
      <div class="guide__label">{{ config.markers[camelCase(status)].label[language.code] }}</div>
    </div>
  </div>
</template>
<script>
import { camelCase } from "lodash";
import { mapGetters } from "vuex";
import AvailabilityMarker from "./AvailabilityMarker.vue";
export default {
  components: { AvailabilityMarker },

  computed: {
    ...mapGetters({
      config: "newConfig",
      language: "language",
    }),
  },

  methods: {
    camelCase(string) {
      return camelCase(string);
    },
  },
};
</script>
<style lang="scss">
.guide {
  align-items: center;
  display: flex;
  margin: 0 0 2rem;
  position: relative;

  &__label {
    padding-left: 3rem;
  }

  .availability-marker {
    padding: 2rem;
    position: absolute;
    transform: translate(-1rem, 0rem);
    z-index: var(--tag-z-index);

    .availability-marker__dot {
      background-color: var(--marker-color);
      color: #fff;
    }

    .availability-marker__icon {
      display: block;
      width: 60%;
    }

    &--filtered {
      pointer-events: none !important;

      .availability-marker__count,
      .availability-marker__dot {
        filter: grayscale(100%);
        opacity: 0.5;
      }
    }

    &__dot {
      border-radius: 50%;
      border: 0.2rem solid white;
      box-shadow: -0.2rem 0.3rem 0.3rem rgba(0, 0, 0, 0.35);
      height: 2rem;
      // transition: all 0.3s;
      width: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      svg {
        display: none;
        font-size: 1.2em;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &__ring {
      border: 0.3rem solid #fff;
      border-radius: 3rem;
      height: 2rem;
      width: 2rem;
      position: absolute;
      animation: pulsate 2s ease-out;
      animation-iteration-count: infinite;
      opacity: 0;
    }
  }
}
</style>
